import { mergeStyles } from '@fluentui/react';

const chatAreaContainerStyle = mergeStyles({
  height: '100%',
  width: '100%',
  marginLeft: '6%',
  marginRight: '6%',
  paddingBottom: '1rem',
  overflow: 'auto'
});

export { chatAreaContainerStyle };
